import styled from 'styled-components';
import Partners from '../../../static/partners.png';

export const Container = styled.div`
  padding: 30px 20px;
  text-align: center;
`;

export const SecTitle = styled.h3`
  color: #93b8c9;
  font-size: 2em;
  font-weight: 300;
  position: relative;
  margin-bottom: 25px;
  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 3px;
    background-color: #e7e516;
    position: absolute;
    left: 0;
    right: 0;
    top: 40px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const PartnerImg = styled.div`
  width: 100%;
  &:before {
    content: '';
    background: transparent url(${Partners}) no-repeat;
    background-size: cover;
    padding-bottom: 59.73333333%;
    display: block;
  }
`;
